module.exports = __webpack_public_path__ + "img/ic-drop-down-white.86a23e30.svg";